'use client';

import GtagService from '@/services/Gtag.service';
import Image from 'next/image';
import icoWhatsapp from '@/public/images/whatsapp_icon.svg';

function sendWhatsappTracking() {
  GtagService.customEvent(`whatsapp_invite_group`, { category: `click`, type: `footer` });
}

export default function LinkCanalWhatsapp() {
  return (
    <a
      onClick={sendWhatsappTracking}
      href="https://whatsapp.com/channel/0029Vb5my6a5kg7CYjQ9tg16"
      target="_blank"
      rel="noreferrer"
    >
      <div className="footer-whatsapp-header">
        <Image width={25} height={25} src={icoWhatsapp} alt="Whatsapp" />
        <div className="container">
          <p>Clique aqui para entrar no canal do Whatsapp </p>
        </div>
      </div>
    </a>
  );
}
